import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_485e2b94 from 'nuxt_plugin_sentryserver_485e2b94' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_761778ae from 'nuxt_plugin_sentryclient_761778ae' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_pluginutils_3a8ae409 from 'nuxt_plugin_pluginutils_3a8ae409' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_79629314 from 'nuxt_plugin_pluginrouting_79629314' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_29c150db from 'nuxt_plugin_pluginmain_29c150db' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_portalvue_365f2721 from 'nuxt_plugin_portalvue_365f2721' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_axios_db3c871c from 'nuxt_plugin_axios_db3c871c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gtm_dfaa1070 from 'nuxt_plugin_gtm_dfaa1070' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_app_78d3aa66 from 'nuxt_plugin_app_78d3aa66' // Source: ../plugins/app.js (mode: 'all')
import nuxt_plugin_algolia_45875fc6 from 'nuxt_plugin_algolia_45875fc6' // Source: ../plugins/algolia.js (mode: 'all')
import nuxt_plugin_cloudinary_109c0ab2 from 'nuxt_plugin_cloudinary_109c0ab2' // Source: ../plugins/cloudinary.js (mode: 'all')
import nuxt_plugin_craftClient_780cf3a3 from 'nuxt_plugin_craftClient_780cf3a3' // Source: ../plugins/craftClient.js (mode: 'all')
import nuxt_plugin_dlPush_cb7ace04 from 'nuxt_plugin_dlPush_cb7ace04' // Source: ../plugins/dlPush.js (mode: 'all')
import nuxt_plugin_educationCheckout_70a24700 from 'nuxt_plugin_educationCheckout_70a24700' // Source: ../plugins/educationCheckout.js (mode: 'all')
import nuxt_plugin_externalScripts_6270b231 from 'nuxt_plugin_externalScripts_6270b231' // Source: ../plugins/externalScripts.js (mode: 'server')
import nuxt_plugin_graphql_605dcef6 from 'nuxt_plugin_graphql_605dcef6' // Source: ../plugins/graphql.js (mode: 'all')
import nuxt_plugin_gtm_63eb8124 from 'nuxt_plugin_gtm_63eb8124' // Source: ../plugins/gtm.js (mode: 'all')
import nuxt_plugin_localeRootPath_33fa7abf from 'nuxt_plugin_localeRootPath_33fa7abf' // Source: ../plugins/localeRootPath.js (mode: 'all')
import nuxt_plugin_shopifyBuyClient_19013495 from 'nuxt_plugin_shopifyBuyClient_19013495' // Source: ../plugins/shopifyBuyClient.js (mode: 'all')
import nuxt_plugin_shopifyRequest_cf4c9212 from 'nuxt_plugin_shopifyRequest_cf4c9212' // Source: ../plugins/shopifyRequest.js (mode: 'all')
import nuxt_plugin_index_f1e7ee00 from 'nuxt_plugin_index_f1e7ee00' // Source: ../plugins/pickystory/index.js (mode: 'all')
import nuxt_plugin_retour_451c6d15 from 'nuxt_plugin_retour_451c6d15' // Source: ../plugins/retour.js (mode: 'all')
import nuxt_plugin_schema_7d4acebf from 'nuxt_plugin_schema_7d4acebf' // Source: ../plugins/schema.js (mode: 'server')
import nuxt_plugin_tracking_04c0e7a9 from 'nuxt_plugin_tracking_04c0e7a9' // Source: ../plugins/tracking.js (mode: 'all')
import nuxt_plugin_trustedShops_09f6d1fa from 'nuxt_plugin_trustedShops_09f6d1fa' // Source: ../plugins/trustedShops.js (mode: 'all')
import nuxt_plugin_client_f1617668 from 'nuxt_plugin_client_f1617668' // Source: ../plugins/shopify/client.js (mode: 'client')
import nuxt_plugin_exposedFunctions_1a20d485 from 'nuxt_plugin_exposedFunctions_1a20d485' // Source: ../plugins/exposedFunctions.js (mode: 'client')
import nuxt_plugin_auth_39ff967e from 'nuxt_plugin_auth_39ff967e' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_8fed78d0 from 'nuxt_plugin_auth_8fed78d0' // Source: ../plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"blackroll","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","sizes":"16x16","type":"image\u002Fsvg+xml","href":"\u002Ffavicon-16x16.svg"},{"rel":"icon","sizes":"32x32","type":"image\u002Fsvg+xml","href":"\u002Ffavicon-32x32.svg"},{"rel":"apple-touch-icon","sizes":"180x180","type":"image\u002Fpng","href":"\u002Fapple-touch-icon.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#111618"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.cookielaw.org","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googleoptimize.com","crossorigin":false},{"rel":"preconnect","href":"https:\u002F\u002Fgeolocation.onetrust.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fcldn.cdn-blackroll.com","crossorigin":false},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcldn.cdn-blackroll.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fshop.de.blackroll.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fcdn.cookielaw.org"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fgeolocation.onetrust.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fassets.ubembed.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fvitals.vercel-analytics.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.googletagmanager.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fwww.googleoptimize.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fgeolocation.onetrust.com"}],"style":[{"cssText":".async-hide { opacity: 0 !important}"}],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TFVGLQD')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TFVGLQD&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_485e2b94 === 'function') {
    await nuxt_plugin_sentryserver_485e2b94(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_761778ae === 'function') {
    await nuxt_plugin_sentryclient_761778ae(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_3a8ae409 === 'function') {
    await nuxt_plugin_pluginutils_3a8ae409(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_79629314 === 'function') {
    await nuxt_plugin_pluginrouting_79629314(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_29c150db === 'function') {
    await nuxt_plugin_pluginmain_29c150db(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_365f2721 === 'function') {
    await nuxt_plugin_portalvue_365f2721(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_db3c871c === 'function') {
    await nuxt_plugin_axios_db3c871c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dfaa1070 === 'function') {
    await nuxt_plugin_gtm_dfaa1070(app.context, inject)
  }

  if (typeof nuxt_plugin_app_78d3aa66 === 'function') {
    await nuxt_plugin_app_78d3aa66(app.context, inject)
  }

  if (typeof nuxt_plugin_algolia_45875fc6 === 'function') {
    await nuxt_plugin_algolia_45875fc6(app.context, inject)
  }

  if (typeof nuxt_plugin_cloudinary_109c0ab2 === 'function') {
    await nuxt_plugin_cloudinary_109c0ab2(app.context, inject)
  }

  if (typeof nuxt_plugin_craftClient_780cf3a3 === 'function') {
    await nuxt_plugin_craftClient_780cf3a3(app.context, inject)
  }

  if (typeof nuxt_plugin_dlPush_cb7ace04 === 'function') {
    await nuxt_plugin_dlPush_cb7ace04(app.context, inject)
  }

  if (typeof nuxt_plugin_educationCheckout_70a24700 === 'function') {
    await nuxt_plugin_educationCheckout_70a24700(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_externalScripts_6270b231 === 'function') {
    await nuxt_plugin_externalScripts_6270b231(app.context, inject)
  }

  if (typeof nuxt_plugin_graphql_605dcef6 === 'function') {
    await nuxt_plugin_graphql_605dcef6(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_63eb8124 === 'function') {
    await nuxt_plugin_gtm_63eb8124(app.context, inject)
  }

  if (typeof nuxt_plugin_localeRootPath_33fa7abf === 'function') {
    await nuxt_plugin_localeRootPath_33fa7abf(app.context, inject)
  }

  if (typeof nuxt_plugin_shopifyBuyClient_19013495 === 'function') {
    await nuxt_plugin_shopifyBuyClient_19013495(app.context, inject)
  }

  if (typeof nuxt_plugin_shopifyRequest_cf4c9212 === 'function') {
    await nuxt_plugin_shopifyRequest_cf4c9212(app.context, inject)
  }

  if (typeof nuxt_plugin_index_f1e7ee00 === 'function') {
    await nuxt_plugin_index_f1e7ee00(app.context, inject)
  }

  if (typeof nuxt_plugin_retour_451c6d15 === 'function') {
    await nuxt_plugin_retour_451c6d15(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_schema_7d4acebf === 'function') {
    await nuxt_plugin_schema_7d4acebf(app.context, inject)
  }

  if (typeof nuxt_plugin_tracking_04c0e7a9 === 'function') {
    await nuxt_plugin_tracking_04c0e7a9(app.context, inject)
  }

  if (typeof nuxt_plugin_trustedShops_09f6d1fa === 'function') {
    await nuxt_plugin_trustedShops_09f6d1fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_client_f1617668 === 'function') {
    await nuxt_plugin_client_f1617668(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_exposedFunctions_1a20d485 === 'function') {
    await nuxt_plugin_exposedFunctions_1a20d485(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_39ff967e === 'function') {
    await nuxt_plugin_auth_39ff967e(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_8fed78d0 === 'function') {
    await nuxt_plugin_auth_8fed78d0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
